module.exports = __webpack_public_path__ + "static/media/line svg 2.ee79b1ba.svg";